import { InputHTMLAttributes, ReactNode } from 'react';

export const scales = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const;

type Scales = (typeof scales)[keyof typeof scales];

export interface ComponentProps {
  scale?: Scales;
  checked?: boolean;
  onChange: (checked: boolean) => void;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  disabled?: boolean;
  children?: ReactNode;
  inline?: boolean;
  childrenAlignTop?: boolean;
}

export interface InnerProps {
  $scale?: Scales;
  checked?: boolean;
  disabled?: boolean;
}

const _scaleKeys = {
  handleHeight: 'handleHeight',
  handleWidth: 'handleWidth',
  handleLeft: 'handleLeft',
  // handleTop: 'handleTop',
  checkedLeft: 'checkedLeft',
  toggleHeight: 'toggleHeight',
  toggleWidth: 'toggleWidth',
} as const;

export type ScaleKeys = (typeof _scaleKeys)[keyof typeof _scaleKeys];
